import { lazy } from "react";
const Branches = lazy(() => import("../pages/branches/Branches"));
const NewBranch = lazy(() => import("../pages/branches/NewBranch"));
const EditBranch = lazy(() => import("../pages/branches/EditBranch"));
const BranchDetails = lazy(() => import("../pages/branches/BranchDetails"));

export const branchRoutes = [
  {
    path: "/branches",
    component: Branches,
  },
  {
    path: "/branches/create",
    component: NewBranch,
  },
  {
    path: "/branches/edit/:id",
    component: EditBranch,
  },
  {
    path: "/branches/:id",
    component: BranchDetails,
  },
];
